export default () => ({
    procedures: [],
    proceduresLoading: false,
    proceduresInit: true
});
